"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IteratorProxy = void 0;

var _iterableIterator = require("./iterable-iterator");

class IteratorProxy extends _iterableIterator.IterableIterator {
  constructor(iterator) {
    super();
    this.__iterator = iterator;
    this.__done = false;
  }

  next() {
    const item = this.__iterator.next();

    if (item.done || this.__done) {
      const doneItem = {
        value: this.__done ? undefined : item.value,
        done: true
      };
      this.__done = true;
      return doneItem;
    }

    return item;
  }

  return(value) {
    const iterator = this.__iterator;
    const done = this.__done;
    this.__done = true;
    if (typeof iterator.return === 'function' && !done) iterator.return();
    return {
      value,
      done: true
    };
  }

  throw() {
    const iterator = this.__iterator;

    if (typeof iterator.throw === 'function') {
      const item = iterator.throw();
      this.__done = item.done;
      return item;
    } else {
      this.__done = true;
      return {
        value: undefined,
        done: true
      };
    }
  }

}

exports.IteratorProxy = IteratorProxy;